import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Typography } from 'antd';
import classnames from 'classnames';

import { ButtonEditModuleProperties } from 'pages/product-full-view/shared/components';
import {
  useGetWalmartProductData,
  useGetWalmartProductSchema,
} from 'pages/branded-products/components/post-to-walmart-krogger/queries';

import {
  productDetailActionTypes,
  useProductDetail,
  useProductDetailDispatch,
} from '../ProductDetailContext';
import { CollapseView } from '../ShareComponents';

import DisplayWalmartInfo from './DisplayWalmartInfo';
import { WALMART_PRODUCT_INFORMATION } from './constants';
import { mergeDataToSchema } from './utils';
import WalmartProductEdit from './WalmartProductEdit';
import { useCheckAllowEditProducts, useGetProductFullView } from 'hooks';

const WalmartProductModule = (props) => {
  const { searchText } = props;
  const dispatch = useProductDetailDispatch();

  const [visible, setVisible] = useState(false);

  const { id: productId } = useParams();

  const {
    advancedModule: { activeModules },
  } = useProductDetail();

  const { data: walmartProductSchema } = useGetWalmartProductSchema({
    productIds: [productId],
    meta: {
      //skip global error notification
      onError: (error) => false,
    },
  });

  const { productFull } = useGetProductFullView({ productId });

  const { checkAllowEditProductFull } = useCheckAllowEditProducts();

  const { data } = useGetWalmartProductData({
    productIds: [+productId],
    isGetLatestProductData: true,
    enabled: Boolean(walmartProductSchema),
  });

  const { walmartProductProperties } = walmartProductSchema || {};
  const [walmartProductData] = data || [];

  const enrichedData = mergeDataToSchema(
    walmartProductProperties,
    walmartProductData
  );

  const foundModuleName = searchText?.split('.')[0];

  const isFoundModule =
    foundModuleName?.toLowerCase() ===
    WALMART_PRODUCT_INFORMATION.moduleName.toLowerCase();

  const hasModuleName = activeModules.includes(
    WALMART_PRODUCT_INFORMATION.moduleName
  );
  const isAllowEditProduct = checkAllowEditProductFull(productFull);

  const isActiveBtnEdit = hasModuleName && isAllowEditProduct;

  if (!Boolean(walmartProductSchema)) return null;

  return (
    <>
      <CollapseView
        activeKey={activeModules}
        key={WALMART_PRODUCT_INFORMATION.moduleName}
        expandIconPosition='left'
        keyPanel={WALMART_PRODUCT_INFORMATION.moduleName}
        headerPanel={
          <Typography.Title
            level={5}
            className={classnames({
              'product-detail-view__list-info-title': true,
              [`product-detail-view__list-info-title--${WALMART_PRODUCT_INFORMATION.moduleName}`]: true,
              'product-detail-view__list-info-title--found-module':
                isFoundModule,
            })}
          >
            Walmart Product Information
          </Typography.Title>
        }
        extraPanel={() => {
          return (
            <>
              {isActiveBtnEdit && (
                <ButtonEditModuleProperties
                  moduleName={WALMART_PRODUCT_INFORMATION.moduleDisplayName}
                  moduleDisplayName={
                    WALMART_PRODUCT_INFORMATION.moduleDisplayName
                  }
                  onClick={() => setVisible(true)}
                />
              )}
            </>
          );
        }}
        onChange={(value) => {
          dispatch({
            type: productDetailActionTypes.ACTIVE_MODULES,
            payload: {
              value,
              moduleView: 'advanced',
            },
          });
        }}
      >
        <DisplayWalmartInfo enrichedData={enrichedData} />
      </CollapseView>
      {visible && (
        <WalmartProductEdit visible={visible} setVisible={setVisible} />
      )}
    </>
  );
};

export default WalmartProductModule;
